/**
 * Auth utilities for SSE/streaming fetch() calls that can't use the axios interceptor.
 */

import { supabase } from '@/services/supabaseClient';

const DISABLE_AUTH = import.meta.env.VITE_DISABLE_AUTH === 'true';

/**
 * Get Authorization headers from the current Supabase session.
 * Returns an empty object if no session exists (e.g. auth disabled).
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  if (DISABLE_AUTH) {
    return { Authorization: 'Bearer dev-bypass-token' };
  }

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      return { Authorization: `Bearer ${session.access_token}` };
    }
  } catch {
    // Fail silently — auth may be disabled
  }
  return {};
}
